"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$default;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var searchPlaceTypes_1 = require("./searchPlaceTypes");

exports.default = (_exports$default = {}, _defineProperty(_exports$default, searchPlaceTypes_1.CITY, 10460), _defineProperty(_exports$default, searchPlaceTypes_1.COUNTY, 32186), _defineProperty(_exports$default, searchPlaceTypes_1.NEIGHBORHOOD, 1207), _defineProperty(_exports$default, searchPlaceTypes_1.TOWN, 3218), _exports$default);